import { Compiler } from '@/dsl/compilers';
import { formatSubscription } from '@/renders/format';
import type { UnifiedContext } from '../context';

export const handleSubscription = (el: HTMLElement, ctx: UnifiedContext) => {
  const {
    storeSubscription,
    storeSubscriptionType,
    storeTextSingle,
    storeTextMany
  } = el.dataset;
  if (storeSubscription === undefined) return;
  const option = ctx.option;
  if (!option) return;

  const type = storeSubscriptionType === 'months' ? 'months' : 'years';

  // input
  if (el instanceof HTMLInputElement) {
    const value = type === 'months' ? option.getSubscription() : Math.floor(option.getSubscription() / 12);
    el.value = String(value);
    return;
  }

  // select
  if (el instanceof HTMLSelectElement) {
    const selectedSubscription = option.getSubscription();
    const available = Compiler.array(storeSubscription) ?? option.getProduct().getSubscriptions().values;

    el.options.length = 0;
    for (const sub of available) {
      const isSelected = sub === selectedSubscription;
      const text = formatSubscription(
        sub,
        type,
        storeTextSingle,
        storeTextMany
      );
      const htmlOption = new Option(
        text,
        String(sub),
        isSelected,
        isSelected
      );
      htmlOption.setAttribute('data-store-set-subscription', String(sub));
      el.add(htmlOption);
    }
    return;
  }

  // generic content
  el.textContent = formatSubscription(option.getSubscription(), type, storeTextSingle, storeTextMany);
};
